$(function () {
  if ($("body").hasClass("post-type-archive-trend")) {
    // DOM要素のキャッシュ（存在しない場合もあるので後で都度チェック）
    const radioButtons = document.querySelectorAll('input[name="filter"]');
    const filterResultPC = document.getElementById("filterResultPC");
    const filterResultSP = document.getElementById("filterResultSP");
    const dynamicLinkPC = document.getElementById("dynamicLinkPC");
    const dynamicLinkSP = document.getElementById("dynamicLinkSP");
    const titleElement = document.querySelector(".p-FilterTitle__text span b");

    // ACFから出力されたフィルターリンク情報
    const links = window.caseCategoryLinks || {};

    /**
     * フィルターリンクをPC/SPそれぞれに設定して表示する
     */
    function showFilterLink(linkData) {
      const linkText = `${linkData.label}関連の用途事例はこちら`;

      if (dynamicLinkPC && filterResultPC) {
        dynamicLinkPC.href = linkData.url;
        dynamicLinkPC.textContent = linkText;
        filterResultPC.style.display = "block";
      }

      if (dynamicLinkSP && filterResultSP) {
        dynamicLinkSP.href = linkData.url;
        dynamicLinkSP.textContent = linkText;
        filterResultSP.style.display = "block";
      }
    }

    /**
     * フィルターリンクの表示を非表示にする
     */
    function hideFilterLink() {
      if (filterResultPC) filterResultPC.style.display = "none";
      if (filterResultSP) filterResultSP.style.display = "none";
    }

    /**
     * 現在選択されているフィルターに応じてリンクとタイトルを更新
     */
    function updateFilter() {
      const selectedRadio = document.querySelector('input[name="filter"]:checked');
      if (!selectedRadio) return;

      const selectedValue = selectedRadio.value;
      const label = selectedRadio.closest("label");
      const labelText = label ? label.textContent.trim() : "すべて";

      const linkData = links[selectedValue];

      if (linkData && linkData.url) {
        showFilterLink(linkData);
      } else {
        hideFilterLink();
      }

      if (titleElement) {
        titleElement.textContent = labelText;
      }
    }

    /**
     * フィルターを初期状態（"すべて"）に戻し、投稿リストとリンクもリセット
     */
    function resetFilter() {
      const $posts = $(".p-Posts__col");
      const $filterRadios = $('input[name="filter"]');

      // ラジオボタンを "すべて" に戻す
      $filterRadios.prop("checked", false);
      $filterRadios.filter('[value="all"]').prop("checked", true);

      // URLパラメータ `?filter=` を削除
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete("filter");
      history.pushState(null, "", newUrl);

      // 投稿表示をリセットして再表示
      $posts.stop(true, true).css("opacity", 0).show().animate({ opacity: 1 }, 300);

      // タイトル・リンクも初期化
      if (titleElement) {
        titleElement.textContent = "すべて";
      }

      hideFilterLink();
      updateFilter();
    }

    /**
     * フィルタータブのクリック動作を初期化
     */
    function setupTabs() {
      const $tabs = $(".post-type-archive-trend .p-TabMenu__btnList li");

      $tabs.on("click", function () {
        if ($(this).hasClass("current")) return;

        const tabId = $(this).data("tab");

        $tabs.removeClass("current");
        $(this).addClass("current");

        $(".c-tabContents__box").hide();
        $("#" + tabId).fadeIn(300);

        // URLハッシュを更新
        history.replaceState(null, null, "#" + tabId);

        resetFilter();
      });

      const hash = window.location.hash.replace("#", "");
      if (hash) {
        const $targetTabBtn = $tabs.filter(function () {
          return $(this).data("tab") === hash;
        });

        if ($targetTabBtn.length) {
          $tabs.removeClass("current").map((_, el) => $("#" + $(el).data("tab")).hide());
          $targetTabBtn.addClass("current");
          $("#" + hash).show(); // 対象コンテンツ表示
          return;
        }
      }

      $tabs.first().trigger("click"); // 初期タブを表示
    }

    /**
     * 初期化処理（読み込み時に一度だけ実行）
     */
    function initialize() {
      setTimeout(() => {
        // ラジオボタン変更時にも反映
        radioButtons.forEach((radio) => {
          radio.addEventListener("change", updateFilter);
        });

        // タブのセットアップ（ここで resetFilter() が実行される）
        setupTabs();

        // 🔽 resetFilter の後で上書きされないように、setTimeout でさらに後に動かす
        setTimeout(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const filter = urlParams.get("filter");

          if (filter && window.matchMedia("(max-width: 767px)").matches) {
            const $targetRadio = $(`input[name="filter"][value="${filter}"]`);
            if ($targetRadio.length) {
              $targetRadio.prop("checked", true).trigger("change");
              updateFilter();
            }
          }
        }, 100); // resetFilter() の後に確実に実行
      }, 50);
    }

    // JS初期化実行
    initialize();

    $(window).on("hashchange", function () {
      const hash = window.location.hash.replace("#", "");

      if (!hash) return;

      const $tabs = $(".post-type-archive-trend .p-TabMenu__btnList li");
      const $targetTab = $tabs.filter(function () {
        return $(this).data("tab") === hash;
      });

      if ($targetTab.length) {
        $tabs.removeClass("current");
        $targetTab.addClass("current");

        $(".c-tabContents__box").hide();
        $("#" + hash).fadeIn(300);

        resetFilter(); // お好みで実行
      }
    });
  }
});
